export const environment = {
    production: true,
    apiBaseUrl: 'https://asse-api.iapmo.org/',
    mediaBaseUrl: 'https://scb-media.iapmo.org/',
    documentGeneratorBaseUrl: 'https://generator.iapmo.org/',
    msalClientId: 'f4ff901b-7dc1-4a8b-b4d8-fe524101fc3b',
    msalTenantId: '21931cb4-d51f-475c-ad31-98d48783abce',
    redirectUri: 'https://asse.iapmo.org/auth-callback',
};
